export const pluralizer = (length, name) => {
    if (length === 1) return name;
    if (name === 'this') return 'these'
    return name + 's'
}